<template>
  <div class="balance">
    <Navbar title="余额"/>
    <div class="topBg clearfix balance-top">
      <div class="amount">￥{{ balance }}</div>
      <div class="btnGroup">
        <button @click="toPages('/my/withdraw')">提现</button>
        <button @click="toPages('/food/deposit')" class="themeColor">充值</button>
      </div>
    </div>
    <div class="amount-detail">
      <div class="choose">
        <div class="choose-type">
          <div @click="showType = !showType">
            <span>{{ typeText }}</span>
            <img src="../../assets/images/triangle_down.png" alt="">
          </div>
        </div>
        <div class="choose-date">
          <div @click="showDate = !showDate">
            <span> {{ date }} </span>
            <img src="../../assets/images/triangle_down.png" alt="">
          </div>
        </div>
      </div>
      <van-list
          v-model="loading"
          :finished="finished"
          finished-text="已经到底了..."
          :immediate-check="false"
          offset="50"
          loading-text="加载中..."
          @load="onLoad">
        <div class="list" v-if="balanceList.length > 0">
          <div class="list-item" v-for="(item, index) in balanceList" :key="index">
            <div class="use">
              <span>{{ `${item.name}(${item.userNo})` }}</span>
              <span>{{ item.createTime }}</span>
            </div>
            <div class="amount">
              <span>{{ item.content }}</span>
              <span :class="item.amount >= 0 ? 'greenFoot' : 'orangeFoot'">
                {{ item.amount >= 0 ? '+' + item.amount : item.amount }}
              </span>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <van-popup v-model="showType" position="bottom" :style="{ height: '50%' }">
      <van-picker title="" show-toolbar :columns="typeArr" @cancel="offType" @confirm="onChooseType"/>
    </van-popup>
    <van-popup v-model="showDate" position="bottom" :style="{ height: '50%' }">
      <van-datetime-picker v-model="currentDate" type="year-month" title="选择年月" :min-date="minDate" :max-date="maxDate"
                           :formatter="formatter" @cancel="offDate" @confirm="onChooseDate"/>
    </van-popup>
  </div>
</template>

<script>
import Navbar from "../../components/NavBar";

export default {
  name: "balance",
  components: {Navbar},
  data() {
    return {
      typeText: '',
      typeIndex: 0,
      showType: false,
      typeArr: ['全部', '充值', '支出'],

      showDate: false,
      date: '',
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),

      balanceList: [],
      balance: '',
      pageNum: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      timer: null,
      totalSize: 0
    }
  },
  created() {
    this.typeText = this.typeArr[this.typeIndex];
    this.date = this.getTimes.timestampToYearMonth(new Date())
  },
  mounted() {
    this.onLoad()
  },
  methods: {
    onLoad() {
      let data = {
        date: this.date,
        type: this.typeIndex,
        pageSize: this.pageSize,
        pageNum: this.pageNum
      }
      setTimeout(() => {
        this.$post('user/balanceList', data).then((res) => {
          if (res.status == 200) {
            this.balance = res.data.balance || '0.00'
            this.total = res.data.info.total;
            // res.data.info.list.map((item) => {
            //   item.time = this.getTimes.timestampToTime(item.createTime)
            //   this.balanceList.push(item);
            // })
            this.balanceList = [...this.balanceList, ...res.data.info.list]
            this.pageNum += 1
            this.loading = false;
            if (this.balanceList.length === this.total) {
              return this.finished = true;
            }
          }
        })
      }, 500)
    },
    toPages(url) {
      this.$router.push(url)
    },
    offType() {
      this.showType = false;
    },
    onChooseType(value, index) {
      this.finished = false;
      this.typeText = value;
      this.typeIndex = index;
      this.showType = false;
      this.balanceList = [];
      this.pageNum = 0;
      this.total = 0
      // this.onLoad()
    },

    offDate() {
      this.showDate = false
    },
    onChooseDate(value) {
      this.finished = false;
      this.date = this.getTimes.timestampToYearMonth(value)
      this.showDate = false;
      this.balanceList = [];
      this.pageNum = 0;
      this.total = 0
      // this.onLoad()
    },
    // 格式化处理
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    }
  }
}
</script>

<style scoped lang="less">
.balance {
  font-size: 14px;

  .balance-top {
    .amount {
      margin-top: 34px;
      font-size: 30px;
      font-weight: bold;
      text-align: center;
    }

    .btnGroup {
      margin-top: 43px;
      display: flex;
      justify-content: center;

      button {
        width: 110px;
        height: 36px;
        border-radius: 18px;
        border: none;
        background: transparent;
        font-size: 15px;
        font-weight: bold;
      }

      button:nth-child(1) {
        border: 1.5px solid #FFFFFF;
      }

      button:nth-child(2) {
        margin-left: 35px;
      }
    }
  }

  .amount-detail {
    margin-top: -40px;

    .choose {
      height: 44px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 15px;
      box-sizing: border-box;
      font-size: 15px;
      background: #FFFFFF;

      .choose-type,
      .choose-date {
        display: flex;
        align-items: center;
        position: relative;

        img {
          width: 10px;
          height: 6px;
          margin-left: 9px;
        }
      }
    }

    .list {
      margin-top: 10px;

      .list-item {
        margin-top: 5px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        background: #FFFFFF;
        padding: 10px 15px;
        box-sizing: border-box;
        font-size: 15px;

        .use {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 10px;

          span:nth-child(2) {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            color: #CCCCCC;
          }
        }

        .amount {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 15px;
        }

        .greenFoot {
          color: #2DAA45;
        }

        .orangeFoot {
          color: #FC3912;
        }
      }

      .list-item:first-child {
        margin-top: 0;
      }

      .toEnd {
        display: flex;
        justify-content: center;
        margin-top: 20px;
        padding-bottom: 20px;
        color: #CCCCCC;
      }
    }
  }

  .loading {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>